import { render } from "./index.vue?vue&type=template&id=197f5c24&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=197f5c24&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197f5c24"]])

export default __exports__